<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Kas Masuk</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-form-group label="Cabang">
                        <multiselect
                            name="cabangKasMasuk"
                            v-model="input.cabangKasMasuk" 
                            :options="filterCabang" 
                            :internal-search="true"
                            :allow-empty="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                        />
                        <!-- <b-form-select v-model="input.cabangKasMasuk" name="cabangKasMasuk" :options="filterCabang" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select> -->
                    </b-form-group>
                    <b-form-group label="Nominal">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalKasMasuk" name="nominalKasMasuk" required></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Keterangan">
                        <b-form-textarea v-model="input.keteranganKasMasuk" name="keteranganKasMasuk" required></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="kasMasukSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Kas Masuk" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput kas masuk ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'input-kas-masuk',
    data(){
        return{
            initStatus: 0,
            isBusy: false,
            isSubmitting: false,
            input: {
                cabangKasMasuk: null,
                nominalKasMasuk: null,
                keteranganKasMasuk: ""
            },
            cabangOption: []
        }
    },
    methods:{
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getCabang = localStorage.getItem("cabang")
            this.filterCabang = JSON.parse(getCabang)

            Promise.all([getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        onSubmit() {
            //back to list kas masuk
            let payload = new FormData()
            
            let nominal = this.$helper.removeThousandSeparator(this.input.nominalKasMasuk)

            payload.append("cabangId", this.input.cabangKasMasuk.id)
            payload.append("nominal", nominal)
            payload.append("keterangan", this.input.keteranganKasMasuk)

            //----------------- Submit Semua Data -----------------
            
            this.isSubmitting = true
            
            this.$axios.post("cabang/kas/masuk/", payload).then(() => {
                this.$helper.setFlash(`Input Kas Masuk telah berhasil!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") 
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        openModalConfirm(){
            if(this.input.cabangKasMasuk == null){
                this.$helper.toastErr(this, "Mohon pilih cabang terlebih dahulu !")
            }else{
                this.$bvModal.show("modal-confirm-input")
            }
        }
    },
    watch: {
        "input.nominalKasMasuk": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalKasMasuk = result);
        },
    },
    created(){
        this.init()
    }
}
</script>
